import React, { useState, useRef } from "react"
import { CSVLink } from "react-csv"
import { numberWithCommas } from "utils/HelperFunc"
import { Button } from "antd"
import moment from "moment"
import * as AuthRequest from "services/auth"

export default ({
  username,
  perPage,
  from,
  to,
  service,
  allSkins,
  activeSkinId,
  provider_name,
  card,
}) => {
  const csvLinkRef = useRef(null)
  const [exportData, setExportData] = useState([])
  const [isCsvLoading, setIsCsvLoading] = useState(false)

  const getFullData = async () => {
    setIsCsvLoading(true)
    try {
      const response = await AuthRequest.fetchPayments(
        username,
        from,
        to,
        "",
        perPage,
        activeSkinId && activeSkinId != -1 ? activeSkinId : "",
        "special",
        service,
        "",
        "",
        "",
        provider_name,
        activeSkinId === -1 ? true : undefined,
        card,
      )

      const rawData = response?.data?.transactions || []

      const mappedData = rawData.map((pay) => {
        return allSkins
          ? {
              Date_Ora: pay.Date_Ora,
              Barcode: pay.Barcode ? `="${pay.Barcode}"` : "",
              User: pay.User,
              Username: pay.Username,
              Service: pay.Service,
              Importo: pay.Importo,
              Commisione: (pay.Commisione || 0) + " €",
              Proviggione: (pay.Proviggione || 0) + " €",
            }
          : {
              executed_date: pay.executed_date
                ? `\t${moment(pay.executed_date).format("DD/MM/YY HH:mm")}`
                : "",
              barcode: pay.barcode ? `\t${pay.barcode}` : "",
              agency_name: pay.agency_name,
              service_name: pay.service_name,
              price1000:
                pay.service_name === "Adyen"
                  ? "-"
                  : numberWithCommas(pay.price1000 / 100) + " €",
              commissione: (pay.commissione || 0) + " €",
              percentage: (pay.percentage || 0) + " €",
              agent_profit: (pay.agent_profit ?? "-") + " €",
              skin_profit: (pay.skin_profit ?? "-") + " €",
              system_aggio: (pay.system_aggio ?? "-") + " €",
              saldo: (pay.saldo ?? "-") + " €",
            }
      })

      setExportData(mappedData)
      setIsCsvLoading(false)
      return mappedData
    } catch (error) {
      console.error("Export error:", error)
      setIsCsvLoading(false)
      return []
    }
  }

  const csvHeaders = allSkins
    ? [
        { label: "Date / Ora", key: "Date_Ora" },
        { label: "Barcode", key: "Barcode" },
        { label: "Utente", key: "User" },
        { label: "Username", key: "Username" },
        { label: "Service", key: "Service" },
        { label: "Importo", key: "Importo" },
        { label: "Commissione", key: "Commisione" },
        { label: "Proviggione", key: "Proviggione" },
      ]
    : [
        { label: "Date / Ora", key: "executed_date" },
        { label: "Barcode", key: "barcode" },
        { label: "User", key: "agency_name" },
        { label: "Service", key: "service_name" },
        { label: "Importo", key: "price1000" },
        { label: "Commissione", key: "commissione" },
        { label: "Proviggione", key: "percentage" },
        { label: "Agente", key: "agent_profit" },
        { label: "Skin", key: "skin_profit" },
        { label: "Sistema", key: "system_aggio" },
        { label: "Saldo", key: "saldo" },
      ]

  return (
    <React.Fragment>
      <Button
        loading={isCsvLoading}
        size="small"
        style={{
          border: "none",
          display: "inline-flex",
          alignItems: "center",
          color: "#0078ff",
          background: "transparent",
        }}
        onClick={async () => {
          const data = await getFullData()
          if (data.length > 0) {
            setTimeout(() => {
              if (csvLinkRef.current && csvLinkRef.current.link) {
                csvLinkRef.current.link.click()
              }
            }, 200)
          }
        }}
      >
        <i
          className="far fa-file-csv"
          style={{ marginRight: "4px", fontSize: "16px", fontWeight: 700 }}
        />
        .Csv
      </Button>

      <CSVLink
        data={exportData}
        headers={csvHeaders}
        filename={`transazioni_${from}_${to}.csv`}
        ref={csvLinkRef}
        style={{ display: "none" }}
      />
    </React.Fragment>
  )
}
